import styled from 'styled-components'

export const DateRangeCalendarWrapper = styled.div`
	width: 100%;

	.react-datepicker-popper {
		z-index: 9999 !important;
	}

	.react-datepicker {
		display: block;
		width: 100%;
		border: 1px solid #e0e0e0;
		border-radius: 12px;
		font-family: inherit;
	}

	.react-datepicker__month-container {
		float: none;
		width: 100%;
	}

	.react-datepicker-wrapper {
		width: 100%;
	}

	.react-datepicker__header {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		border-bottom: none;
		border-radius: 12px 12px 0 0;
		padding: 12px;
	}

	.react-datepicker__current-month {
		display: none;
	}

	.react-datepicker__header__dropdown {
		display: flex;
		justify-content: center;
		gap: 8px;
		margin-top: 8px;
	}

	.react-datepicker__month-dropdown-container,
	.react-datepicker__year-dropdown-container {
		display: inline-flex;
	}

	.react-datepicker__month-select,
	.react-datepicker__year-select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		background-color: #fff;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23004b8d' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
		background-repeat: no-repeat;
		background-position: right 8px center;
		color: ${props => props.theme.colors.brand.blueOmint};
		border: none;
		border-radius: 6px;
		padding: 4px 24px 4px 8px;
		font-size: 13px;
		font-weight: 600;
		cursor: pointer;
		text-transform: capitalize;
	}

	.react-datepicker__navigation {
		top: 18px;
		width: 12px;
		height: 28px;
		overflow: visible;
	}

	.react-datepicker__navigation--previous {
		left: 8px;
	}

	.react-datepicker__navigation--next {
		right: 8px;
	}

	.react-datepicker__navigation-icon::before {
		border-color: #fff;
		border-width: 2px 2px 0 0;
		width: 8px;
		height: 8px;
	}

	.react-datepicker__day-names {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 2px;
		margin: 0;
		background: transparent;
	}

	.react-datepicker__day-name {
		font-size: 12px;
		font-weight: 600;
		color: #fff;
		text-align: center;
		padding: 4px 0;
	}

	/* Ensure weekday names and day cells occupy identical columns */
	.react-datepicker__day-name,
	.react-datepicker__day {
		width: 100%;
		margin: 0;
		box-sizing: border-box;
	}

	.react-datepicker__month {
		margin: 0;
		display: grid;
		gap: 2px;
		padding: 0 12px 12px 12px;
	}

	.react-datepicker__week {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 2px;
		margin: 0;
	}

	.react-datepicker__day {
		aspect-ratio: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		color: #333;
		border: none;
		border-radius: 6px;
		background: #fff;
		cursor: pointer;
		transition: all 0.2s ease;
		padding: 0;

		&:hover:not(.react-datepicker__day--outside-month) {
			background: #eff5ff;
			color: #333;
		}
	}

	&& .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selecting-range-start):not(.react-datepicker__day--selecting-range-end) {
		background-color: #eff5ff;
		color: #333;
		border-radius: 6px;

		&:hover {
			background-color: #eff5ff;
			color: #333;
		}
	}

	.react-datepicker__day--in-range {
		background-color: ${props => props.theme.colors.brand.backgroundBlue};
		color: #333;
		border-radius: 6px;

		&:hover {
			background-color: ${props => props.theme.colors.brand.backgroundBlue};
		}
	}

	&& .react-datepicker__day--selected,
	&& .react-datepicker__day--range-start,
	&& .react-datepicker__day--range-end,
	&& .react-datepicker__day--selecting-range-start,
	&& .react-datepicker__day--selecting-range-end {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: #fff;
		font-weight: 600;
		border-radius: 6px;

		&:hover {
			background-color: ${props => props.theme.colors.brand.blueOmint};
			color: #fff;
		}
	}

	.react-datepicker__day--keyboard-selected {
		background-color: transparent;
		color: #333;
		border-radius: 6px;
	}

	&.has-range-selection .react-datepicker__day--keyboard-selected {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: #fff;
		font-weight: 600;
		border-radius: 6px;

		&:hover {
			background-color: ${props => props.theme.colors.brand.blueOmint};
		}
	}

	.react-datepicker__day--keyboard-selected.react-datepicker__day--selected,
	.react-datepicker__day--keyboard-selected.react-datepicker__day--range-start,
	.react-datepicker__day--keyboard-selected.react-datepicker__day--range-end,
	.react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range-start,
	.react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range-end {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: #fff;
		border-radius: 6px;
	}

	.react-datepicker__day--outside-month {
		color: #ccc;
		cursor: not-allowed;
	}

	.react-datepicker__day--disabled {
		color: #ccc;
		cursor: not-allowed;
	}

	.react-datepicker__close-icon {
		top: auto;
		bottom: 0;
		right: 12px;
		height: 40px;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.react-datepicker__close-icon::after {
		background-color: transparent;
		color: ${props => props.theme.colors.text.primaryText};
		border-radius: 0;
		height: auto;
		width: auto;
		padding: 0;
		font-size: 18px;
		line-height: 1;
	}
`
